import classNames from 'classnames';

import lang from '../../lib/language';

import { useIsMobile } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';

import Row from './Row';

import styles from './TournamentRulesModal.module.scss';

type Props = {
  isDisplayTournamentRulesModal: boolean;
  setIsDisplayTournamentRulesModal: (value: boolean) => void;
};

const TournamentRulesModal = (props: Props) => {
  const { isDisplayTournamentRulesModal, setIsDisplayTournamentRulesModal } = props;

  const { isMobile } = useIsMobile();

  if (!isDisplayTournamentRulesModal) {
    return <></>;
  }

  return (
    <div className={classNames(styles.mainWrapper, { [styles.mobileContent]: true })}>
      <div
        className={classNames(styles.wrapperContent, {
          [styles.mobileContentSize]: true,
          [styles.mobileContentGap]: isMobile,
          [styles.webContentRadius]: !isMobile,
        })}
      >
        <div className={styles.body}>
          <h6 className={styles.title}>{lang.commonMyPositionTournamentRules()}</h6>

          <Row
            category={lang.commonMyPositionTournamentRegistration()}
            items={[lang.commonMyPositionTournamentRegistrationItem1(),
              lang.commonMyPositionTournamentRegistrationItem2()]}
          />

          <Row
            category={lang.commonMyPositionTournamentPeriod()}
            items={[lang.commonMyPositionTournamentPeriodItem1(),
              lang.commonMyPositionTournamentPeriodItem2()]}
          />
          <Row
            category={lang.commonMyPositionTournamentCommercialActivities()}
            items={[lang.commonMyPositionTournamentCommercialActivitiesItem1(),
              lang.commonMyPositionTournamentCommercialActivitiesItem2()]}
          />

          <Row
            category={lang.commonMyPositionTournamentEvaluation()}
            items={[lang.commonMyPositionTournamentEvaluationItem1(),
              lang.commonMyPositionTournamentEvaluationItem2()]}
          />

          <Row
            category={lang.commonMyPositionTournamentAwards()}
            items={[lang.commonMyPositionTournamentAwardsItem1(),
              lang.commonMyPositionTournamentAwardsItem2()]}
          />

          <Row
            category={lang.commonMyPositionTournamentCompliance()}
            items={[lang.commonMyPositionTournamentComplianceItem1(),
              lang.commonMyPositionTournamentComplianceItem2()]}
          />

          <Row
            category={lang.commonMyPositionTournamentChanges()}
            items={[lang.commonMyPositionTournamentChangesItem1()]}
          />

          <Button
            className={styles.button}
            variant={ButtonTypesEnum.Primary}
            onClick={() => setIsDisplayTournamentRulesModal(false)}
          >
            {lang.commonClose()}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TournamentRulesModal;
